import React from 'react';
import { NavLink } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className='footer'>
      <ul>
        <li><NavLink to="/Terms-of-Service" className={({ isActive }) => isActive ? 'active' : ''}>Terms of Service</NavLink></li>
        <li><NavLink to="/Privacy-Policy" className={({ isActive }) => isActive ? 'active' : ''}>Privacy Policy</NavLink></li>
        <li><NavLink to="/FAQs" className={({ isActive }) => isActive ? 'active' : ''}>FAQs</NavLink></li>
        <li><a href="#">(Social Media Badges here)</a></li>
      </ul>
      <p>DJ's Dog Bar &copy; 2025</p>
    </footer>
  );
}

export default Footer;
